(function()
{
    //Import classes
    var 
        BasePanel = include('springroll.easeljs.BasePanel'),
        Container = include('createjs.Container'),
        Bitmap = include('createjs.Bitmap'),
        SoundButton = include('springroll.easeljs.SoundButton'),
        DwellTimer = include('springroll.easeljs.DwellTimer');

    var boxes = [];

    /**
     *  Panel contains all of the visual elements for the Game state
     *  @class sid.GamePanel
     *  @extends springroll.easeljs.BasePanel
     */
    var GamePanel = function()
    {
        BasePanel.call(this);
    };

    //Super prototype
    var s = BasePanel.prototype;

    //Extend the base panel
    var p = GamePanel.prototype = Object.create(s);

    /**
     *  Setup the state, this happens on each state entering
     */
    p.setup = function()
    {
        /**
         *  A scaling container to keep moving items in
         *  @property {createjs.Container} scalingContainer
         */
        this.scalingContainer = new Container();
        this.addChild(this.scalingContainer);

        /**
         *  The constructed game stage
         *  @property {createjs.Container} skin
         */
        this.skin = new lib.Game();
        this.skin.hero.parent.removeChild(this.skin.hero);
        this.scalingContainer.addChild(this.skin);

        this.smallBoxes = [];
        this.bigBoxes = [];
        this.labels = [];

        this.May = new lib.May();
        this.May.x = -130;
        this.May.y = 50;
        this.May.name = "May";
        this.May.cursor = "pointer";
        this.May.mouseEnabled = true;
        this.May.mouseChildren = false;
    };

    /**
     *  Un-setup the panel when exiting the state
     */
    p.teardown = function()
    {
        this.scalingContainer.removeAllChildren();

        s.teardown.call(this); 
        this.skin = null;
        boxes = null;
        this.smallBoxes = null;
        this.bigBoxes = null;
        this.labels = null;
        this.colors = null;
        this.table = null;
        this.May = null;
    };

    p.addLabels = function(sorting_criteria_arg)
    {
        this.colors = [];
        for (i=0; i<sorting_criteria_arg.length ;i++)
        {

            this.boxLabelShapes.gotoAndStop(sorting_criteria_arg[i]);
            label = this.boxLabelShapes.clone(true);
            label.visible = true;
            label.x = (this.smallBox.visible ? 400 : 335) + (i*125);
            label.y = this.smallBox.visible ? 330 : 360;
            this.scalingContainer.addChild(label);
            this.labels.push(label);

            this.colors.push(sorting_criteria_arg[i]);
            //label = box.getChildByName('label0' + (i+1));
            //label.gotoAndStop(sorting_criteria_arg[i]);
        }
    };
    p.removeLabels = function()
    {
        for(var i = this.labels.length - 1; i >= 0; i--)
        {
            var label = this.labels[i];
            label.parent.removeChild(label);
        }
        this.labels = [];
    };

    p.assemble = function(manifest)
    {
        var i,j,shape,container;
        for(i = 0, count = manifest.length; i < count; i++)
        {
            var item = manifest[i];
            var id = item.id.substring(0,1).toLowerCase() + item.id.substring(1);
            if(id.match(/^May/gim)) continue;

            this[id].x = item.x;
            this[id].y = item.y;
            this[id].visible = false;
            this.scalingContainer.addChild(this[id]);
        }

        //generate boxcases
        for(i = 1; i <= 2; i++)
        {
            for(j = 1; j <= 3; j++)
            {
                container = new createjs.Container();
                shape = new createjs.Shape();
                container.name = "boxcase"+ i + j + "_small";
                container.width = 118;
                container.height = 110;
                container.alpha = 0;
                container.row = i;
                container.col = j;
                shape.graphics.beginFill("#ff0000");
                shape.graphics.rect(0,0,118,110);
                shape.graphics.endFill();
                container.addChild(shape);
                this.scalingContainer.addChild(container);
                this.smallBoxes.push(container);
                boxes.push(container);
            }
        }

        //generate boxcases
        for(i = 1; i <= 3; i++)
        {
            for(j = 1; j <= 4; j++)
            {
                container = new createjs.Container();
                shape = new createjs.Shape();
                container.name = "boxcase"+ i + j;
                container.width = 118;
                container.height = 100;
                container.alpha = 0;
                container.row = i;
                container.col = j;
                shape.graphics.beginFill("#00ff00");
                shape.graphics.rect(0,0,118,100);
                shape.graphics.endFill();
                container.addChild(shape);
                this.scalingContainer.addChild(container);
                this.bigBoxes.push(container);
                boxes.push(container);
            }
        }
        this.smallBox = this.box2x3;
        this.bigBox = this.box4x3 = this.box4x4;

        var tablebg = new Bitmap(images.Table);
        var table = this.table = new Container();
        table.name = "table";
        table.addChild(tablebg);
        table.x = 0;
        table.y = 435;
        this.scalingContainer.addChild(table);
        this.scalingContainer.addChild(this.May);

        this.replayButton = new SoundButton(images.ReplayButton);
        this.replayButton.x = 420;
        this.replayButton.y = 140;
        this.replayButton.name = "replay-button";
        this.replayButton.scaleX = this.replayButton.scaleY = 0.5;
        this.replayButton.visible = false;
        this.scalingContainer.addChild(this.replayButton);

        DwellTimer.create(this.replayButton);
    };

    p.positionBoxes = function(small){
        var maxRow = small ? 2 : 3;
        var maxCol = small ? 3 : 4;
        var origin = small ? {x: this.box2x3.x - (this.box2x3.getBounds().width/2) + 20, y: this.box2x3.y - (this.box2x3.getBounds().height/2) + 20} : {x: this.box4x3.x- (this.box4x3.getBounds().width/2) + 30, y: this.box4x3.y -(this.box4x3.getBounds().height/2) + 50};
        var available = boxes.filter(function(element){return small ? element.name.match(/small/gim):!element.name.match(/small/gim);});
        boxes.forEach(function(boxcase){boxcase.visible = false;});

        available.forEach(function(boxcase){
            boxcase.x = origin.x + (boxcase.col - 1)*boxcase.width;
            boxcase.y = origin.y + (boxcase.row - 1)*boxcase.height;
            boxcase.visible = true;
        });

        this.smallBox.visible = small;
        this.bigBox.visible = !small;
    };

    /**
     *  Don't use after this
     */
    p.destroy = function()
    {
        this.scalingContainer = null;
        s.destroy.call(this);
    };

    function trace(){for(var i = 0, count = arguments.length; i < count; i++){if(console) console.log(arguments[i]);}}

    //Assign to namespace
    namespace('sid').GamePanel = GamePanel;
}());
